<template>
  <div class="content">
    <h1>你好，这个是注册页</h1>
  </div>
</template>

<script>
export default {
  title: '注册',
  data () {
    return {
      data: '注册'
    }
  }
}
</script>

<style lang="scss" scoped>
  .content {
    height: 100%;
    width: 100%;
  }
</style>
